import api from "./axios";

export const myCurrentTasks = (params = {}) => api.get("/my/tasks", { params });
// Task-group options for the employee task filters (the admin /task-groups
// endpoint is admin-only).
export const myTaskGroups = () => api.get("/my/task-groups");
export const myPastTasks = (params = {}) => api.get("/my/tasks/history", { params });
export const myCalendarTasks = (params) => api.get("/my/tasks/calendar", { params });
export const myTask = (id) => api.get(`/my/tasks/${id}`);
export const updateMyTaskStatus = (id, payload) => api.patch(`/my/tasks/${id}/status`, payload);
export const setMyTaskClientPending = (id, client_pending) =>
  api.patch(`/my/tasks/${id}/client-pending`, { client_pending });
export const myTaskTransferTargets = (params = {}) =>
  api.get("/my/tasks/transfer-targets", { params });
export const transferMyTask = (id, payload) =>
  api.post(`/my/tasks/${id}/transfer`, payload);

export const listMyTaskNotes = (taskId, params = {}) =>
  api.get(`/my/tasks/${taskId}/notes`, { params });
export const createMyTaskNote = (taskId, payload) =>
  api.post(`/my/tasks/${taskId}/notes`, payload);
export const updateMyTaskNote = (noteId, payload) =>
  api.put(`/my/notes/${noteId}`, payload);
export const deleteMyTaskNote = (noteId) => api.delete(`/my/notes/${noteId}`);
